import * as React from 'react';
import { Icon } from '@teamsnap/teamsnap-ui';

type Props = {
  searchValue: string
  searchPlaceholder?: string
  searchFunction: (x: { searchTerm: string }) => void
}

const BasicSearchFilter = ({ searchValue, searchFunction, searchPlaceholder = 'Search' }: Props) => {
  const [lastSearchValue, setLastSearchValue] = React.useState('');
  const [currentValue, setCurrentValue] = React.useState('');

  React.useEffect(() => {
    setCurrentValue(searchValue);
    setLastSearchValue(searchValue);
  }, [searchValue, setCurrentValue, setLastSearchValue]);

  const handleSearch = React.useCallback(
    (searchStr: string) => {
      searchFunction({ searchTerm: searchStr });
      setLastSearchValue(searchStr);
    },
    [searchFunction, setLastSearchValue]
  );

  const clearAction = React.useCallback(() => {
    setCurrentValue('');
    handleSearch('');
  }, [setCurrentValue, handleSearch]);

  const handleSearchKeyPress = React.useCallback(
    (e) => {
      if (e.key === 'Enter') {
        handleSearch(currentValue);
      }
    },
    [handleSearch, currentValue]
  );

  const showClear = lastSearchValue === currentValue && currentValue !== '';

  return (
    <div className="InputGroup InputGroup--leftIcon InputGroup--iconButton" style={{ width: '100%' }}>
      <input
        value={currentValue}
        name="searchField"
        className="BasicSearch Input Grid-cell"
        placeholder={searchPlaceholder}
        onChange={(e) => setCurrentValue(e.target.value)}
        onKeyPress={handleSearchKeyPress}
        style={{ minWidth: 250 }}
        data-testid="basic-search"
      />
      <button
        type="submit"
        className="InputGroup-icon"
        onClick={showClear ? clearAction : () => handleSearch(currentValue)}
      >
        <Icon className="Icon" mods={null} name={showClear ? 'dismiss' : 'search'} otherProps={{}} style={{}} />
      </button>
    </div>
  );
};

export default BasicSearchFilter;
